import React from 'react';

const StatCard = ({ label, value, accent = 'green' }) => {
  const accentColors = {
    green: 'text-green-500',
    blue: 'text-blue-500',
    yellow: 'text-yellow-500',
    purple: 'text-violet-500',
  };

  return (
    <div className="bg-dark-tertiary border border-dark-border rounded-xl p-5">
      <div className="text-[13px] text-zinc-500 mb-2">
        {label}
      </div>
      <div className={`text-2xl sm:text-3xl font-bold font-mono ${accentColors[accent] || accentColors.green}`}>
        {value}
      </div>
    </div>
  );
};

export default StatCard;
